import * as yup from "yup";

const baseSchema = {
  manufacturingDatePresent: yup
    .string()
    .required("Manufacturing Date Present is required")
    .label("Manufacturing Date Present"),

  manufacturingDate: yup.mixed().when("manufacturingDatePresent", {
    is: (val) => val === "Yes",
    then: () =>
      yup
        .date()
        .typeError("Manufacturing Date must be a valid date")
        .required("Manufacturing Date is required")
        .label("Manufacturing Date"),
    otherwise: () => yup.mixed().notRequired().label("Manufacturing Date"),
  }),

  expiryDatePresent: yup
    .string()
    .required("Expiry Date Present is required")
    .label("Expiry Date Present"),

  expiryDate: yup.mixed().when("expiryDatePresent", {
    is: (expiryPresent) => expiryPresent === "Yes",
    then: () =>
      yup
        .date()
        .typeError("Expiry Date must be a valid date")
        .required("Expiry Date is required")
        .test(
          "is-greater",
          "Expiry Date must be after Manufacturing Date",
          function (value) {
            const { manufacturingDate, manufacturingDatePresent } = this.parent;
            if (
              !value ||
              manufacturingDatePresent !== "Yes" ||
              !manufacturingDate
            ) {
              return true; // skip test
            }
            return new Date(value) > new Date(manufacturingDate);
          }
        )
        .label("Expiry Date"),
    otherwise: () => yup.mixed().notRequired().label("Expiry Date"),
  }),

  brandNamePresent: yup
    .string()
    .required("Brand Name Present is required")
    .label("Brand Name Present"),
  brandName: yup
    .string()
    .when("brandNamePresent", {
      is: (val) => val === "Yes",
      then: yup.string().required("Brand Name is required"),
      otherwise: yup.string().notRequired(),
    })
    .label("Brand Name"),

  manufacturerNamePresent: yup
    .string()
    .required("Manufacturer Name Present is required")
    .label("Manufacturer Name Present"),

  manufacturersName: yup
    .string()
    .matches(/^[a-zA-Z0-9 ]*$/, "Manufacturers Name must be alphanumeric")
    .when("manufacturerNamePresent", {
      is: (val) => val === "Yes",
      then: yup.string().required("Manufacturers Name is required"),
      otherwise: yup.string().notRequired(),
    })
    .label("Manufacturers Name"),

  lotNumberPresent: yup
    .string()
    .required("Lot Number Present is required")
    .label("Lot Number Present"),
  lotNumber: yup
    .string()
    .matches(/^[a-zA-Z0-9]*$/, "Lot Number must be alphanumeric")
    .when("lotNumberPresent", {
      is: (val) => val === "Yes",
      then: yup.string().required("Lot Number is required"),
      otherwise: yup.string().notRequired(),
    })
    .label("Lot Number"),

  packagingType: yup
    .string()
    .required("Packaging Type is required")
    .label("Packaging Type"),

  samplePackedIn: yup
    .string()
    .required("Sample Packed In is required")
    .label("Sample Packed In"), // required
  fssaiLogoPresent: yup
    .string()
    .required("FSSAI Logo Present is required")
    .label("FSSAI Logo Present"), // required
  vegSymbolPresent: yup
    .string()
    .required("Veg Symbol Present is required")
    .label("Veg Symbol Present"), // required
  jaivikBharatSymbolPresent: yup
    .string()
    .required("Jaivik Bharat Symbol Present is required")
    .label("Jaivik Bharat Symbol Present"), // required
  qrCodeId: yup
    .string()
    .required("QR Code Id is required")
    .matches(/^[a-zA-Z0-9]{6}$/, "QR Code Id must be 6 alphanumeric characters")
    .label("QR Code Id"),
  sampleSealNo: yup
    .string()
    .required("Sample Seal No is required")
    // .matches(/^AG-\d{5}$/, "Sample Seal No must be in format AG-12345")
    .label("Sample Seal No"),

  manufacturerPlantAddressPresent: yup
    .string()
    .required("Manufacturing Plant Address Present is required")
    .label("Manufacturing Plant Address Present"),

  manufacturingPlantAddress: yup
    .string()
    .max(250, "Manufacturing Plant Address must be at most 250 characters")
    .when("manufacturerPlantAddressPresent", {
      is: (val) => val === "Yes",
      then: yup
        .string()
        .required("Manufacturing Plant Address is required")
        .max(250, "Manufacturing Plant Address must be at most 250 characters"),
      otherwise: yup.string().notRequired(),
    })
    .label("Manufacturing Plant Address"),

  fssaiLicenseNumberPresent: yup
    .string()
    .required("FSSAI License Number Present is required")
    .label("FSSAI License Number Present"),

  fssaiLicenseNumber: yup
    .string()
    .when("fssaiLicenseNumberPresent", {
      is: (val) => val === "Yes",
      then: yup
        .string()
        .required("FSSAI License Number is required")
        .matches(/^\d{14}$/, "FSSAI License Number must be 14 digits"),
      otherwise: yup.string().notRequired(),
    })
    .label("FSSAI License Number"),

  countryOfOriginPresent: yup
    .string()
    .required("Country of Origin Present is required")
    .label("Country of Origin Present"),
  countryOfOrigin: yup.string().when("countryOfOriginPresent", {
    is: (val) => val === "Yes",
    then: yup
      .string()
      .required("Country of Origin is required")
      .label("Country of Origin"),
    otherwise: yup.string().notRequired(),
  }),
  sampleClaim: yup.string().notRequired().label("Sample Claim"), // not mandatory
  sampleClaimDescription: yup
    .string()
    .notRequired()
    .label("Sample Claim Description"), // not mandatory
};

export const editSampleDetailsSchema = (fields, sampleVariant) => {
  const schema = yup
    .object()
    .shape(
      Object.fromEntries(
        fields.map((field) => [
          field,
          baseSchema[field] || yup.mixed().label(field),
        ])
      )
    );
  return schema;
};
